<template>
  <article class="message proposal-preview">
    <div v-if="propData !== null" class="message-body" :class="proposalStates[propData.outcome].cssClass" >
      <h3 class="title">
        <router-link :to="linkToProposal(propData.outcome)">
          #{{ propNumber + 1 }} - {{ propData.poll.proposal.title }}
        </router-link>
      </h3>
      <div class="field is-grouped is-grouped-multiline">
        <div class="control">
          <div class="tags has-addons">
            <span class="tag is-dark">Proposed By</span>
            <span class="tag is-primary">
            <a class="has-text-white" target="_blank" rel="noopener" :href="tzktLink(propData.poll.author)">
              {{ propData.poll.author }}
            </a>
          </span>
          </div>
        </div>
        <div class="control">
          <div class="tags has-addons">
            <span class="tag is-dark">Proposed In Block</span>
            <span class="tag is-primary">
            <a class="has-text-white" target="_blank" rel="noopener" :href="`${$store.tzstatsURL}/${propData.poll.votingStartBlock}`">
              {{ propData.poll.votingStartBlock.toNumber().toLocaleString() }}
            </a>
          </span>
          </div>
        </div>

        <proposal-outcome :prop-data="propData" />
      </div>
      <tallies :poll-data="propData.poll" />

    </div>
    <div v-else class="message-body">
      <div class="loader-wrapper preview-loader">
        <div class="loader is-large is-primary"></div>
      </div>
    </div>
  </article>
</template>

<script>
import Tallies from "@/components/TallyProgress";
import ProposalOutcome from "@/components/ProposalOutcome";
import Mixins from '../mixins';
export default {
  name: 'ProposalPreview',
  props: {overridePropData: {default: null}, propNumber: {}},
  mixins: [Mixins],
  async mounted(){
    if (this.overridePropData === null){
      const daoContract = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO)
      const daoStorage = await daoContract.storage()
      this.propData = await daoStorage.outcomes.get(this.propNumber.toString())
    } else {
      this.propData = this.overridePropData
    }
  },
  components: {
    ProposalOutcome,
    Tallies
  },
  data(){
    return {
      propData: null,
    }
  },
  methods: {
    linkToProposal(outcome){
      if (outcome === 4){
        return {name: 'Index'}
      } else if (outcome === 1){
        return {name: 'Timelock'}
      } else {
        return {name: 'ProposalDetail', params: {propNumber: this.propNumber + 1}}
      }
    },
  },
  computed: {
    pollData(){
      return this.propData.poll
    }
  }
}
</script>

<style type="text/scss" lang="scss">
@import '../assets/sass/globals';
.proposal-preview{
  .control{
    max-width: 100%;
  }
  .preview-loader{
    padding: 2rem;
  }
  .tag{
    .loader{
      margin-left: .25rem;
    }
  }
  .tallies{
    margin-top: 1rem;
  }
  .message-body{
    &.failed, &.cancelled{
      border-color: $danger;
    }
    &.timelock, &.still-voting{
      border-color: $info;
    }
    &.executed{
      border-color: $primary;
    }
  }
}
</style>
